<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="['field_name', 'department', 'com_name', 'writer_name', 'date']" />
    <div>
      <h5 class="my-4"><i class="dot"></i>{{ $t("안전보건 정보조사 정보") }}</h5>

      <div class="writeGridContainer">
        <div>
          <div>{{ $t("작업(공정)") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.작업공정 }}</p>
          <ml-input v-else class="w-full flex-1" v-model="form.작업공정" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("생산품") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.생산품_1 }}</p>
          <ml-input v-else class="w-full flex-1" v-model="form.생산품_1" :readonly="board.readonly" />
        </div>
        <div>
          <div>{{ $t("생산품") }}</div>
          <p v-if="isPrint" class="print-input">{{ form.생산품_2 }}</p>
          <ml-input v-else class="w-full flex-1" v-model="form.생산품_2" :readonly="board.readonly" />
        </div>

        <div>
          <div>{{ $t("근로자수") }}</div>
          <div class="flex gap-1">
            <p v-if="isPrint" class="print-input">{{ form.근로자수 }}</p>
            <ml-input v-else class="w-full flex-1" v-model="form.근로자수" :readonly="board.readonly" type="number" />
            <p class="content-center">{{ $t("명") }}</p>
          </div>
        </div>
      </div>

      <SafetyInfoSurveyTable v-model="form.안전보건정보조사결과" :readonly="board.readonly" :is-print="isPrint" class="mt-8" />

      <h5 class="my-4"><i class="dot"></i>{{ $t("그 밖의 유해·위험정보 조사결과") }}</h5>
      <!-- 1,2,3 -->
      <div>
        <p class="mid-title mb-2">{{ $t("① 작업표준, 작업절차에 관한 정보") }}</p>
        <div v-if="isPrint" class="print-textarea">{{ form.작업절차정보 }}</div>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.작업절차정보" :readonly="board.readonly" />
      </div>

      <div>
        <p class="mid-title mb-2">{{ $t("② 재해사례, 재해통계 등에 관한 정보") }}</p>
        <div v-if="isPrint" class="print-textarea">{{ form.재해통계정보 }}</div>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.재해통계정보" :readonly="board.readonly" />
      </div>

      <div>
        <p class="mid-title mb-2">{{ $t("③ 기계·기구, 설비 등의 사양서, MSDS 등의 유해·위험요인에 관한 정보 ") }}</p>
        <div v-if="isPrint" class="print-textarea">{{ form.유해위험요인정보 }}</div>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.유해위험요인정보" :readonly="board.readonly" />
      </div>

      <!-- 4 -->
      <table-custom
        :board="board"
        :is-print="isPrint"
        :tableData="[
          { id: '구분', title: $t('구분'), type: 'no', width: '80px' },
          { id: '작업명', title: $t('작업명'), type: 'text', placeholder: $t('작업명') },
          { id: '시작일', title: $t('시작일'), type: 'date', width: '240px' },
          { id: '종료일', title: $t('종료일'), type: 'date', width: '240px' },
          { id: '혼재작업', title: $t('혼재작업 상세'), type: 'text', placeholder: $t('상세내용') },
        ]"
        :mobile="['구분', '작업명']"
        v-model="form.작업상황정보"
        class="mt-28px"
        thema="label"
      >
        <template #customTitle>
          <div class="flex gap-2" style="align-items: center;">
            <p class="mid-title">{{ $t("④ 혼재 작업의 위험성 및 작업상황 등에 관한 정보") }}</p>
            <p class="mid-subtitle">{{ $t("※ 해당 사업장 내 공사 현황 확인(인테리어 공사, 전기공사 등과 사업장 일상 업무가 중복되는 경우)") }}</p>
          </div>

        </template>
      </table-custom>

      <!-- 5 -->
      <div>
        <div class="flex gap-1 mb-2">
          <p class="mid-title">{{ $t("⑤ 근로자 건강진단(건강검진) 결과 특이사항 유무 :") }}</p>
          <radio-group
            :items="[
              { label: '유', value: '유' },
              { label: '무', value: '무' },
            ]"
            v-model="form.특이사항유무"
            :readonly="board.readonly"
            flex
          />
        </div>
        <div v-if="isPrint" class="print-textarea">{{ form.특이사항 }}</div>
        <ml-textarea v-else class="w-full" rows="5" v-model="form.특이사항" :readonly="board.readonly" />
      </div>

      <!-- 6 -->
      <div>
        <table-custom
          :board="board"
          :is-print="isPrint"
          :tableData="[
          { id: '구분', title: $t('구분'), type: 'no', width: '80px' },
          { id: '계약명', title: $t('계약명'), type: 'text', placeholder: $t('계약명') },
          { id: '업체명', title: $t('업체명'), type: 'text', placeholder: $t('업체명') },
          { id: '시작일', title: $t('시작일'), type: 'date', width: '240px' },
          { id: '종료일', title: $t('종료일'), type: 'date', width: '240px' },
          { id: '사업내역', title: $t('사업내역'), type: 'text', placeholder: $t('내용') },
        ]"
          :mobile="['구분', '계약명']"
          v-model="form.도급정보"
          class="mt-28px"
          thema="label"
        >
          <template #customTitle>
            <div class="flex gap-2" style="align-items: center; margin-bottom: 10px;">
              <p class="mid-title">{{ $t("⑥ 도급(일부, 전부 또는 혼재작업) 유무 :") }}</p>
              <radio-group
                :items="[
                  { label: '유', value: '유' },
                  { label: '무', value: '무' },
                ]"
                v-model="form.도급유무"
                :readonly="board.readonly"
                flex
              />
              <p>※ {{ $t("기간") }}</p>
              <p v-if="isPrint">{{ form.도급기간.sDate }} ~ {{ form.도급기간.sDate }}</p>
              <date-selector-rang v-else :readonly="board.readonly" class="flex" v-model="form.도급기간" />
            </div>
          </template>
        </table-custom>

        <div>
          <p class="mid-title mb-2">{{ $t("비고") }}</p>
          <div v-if="isPrint" class="print-textarea">{{ form.도급비고 }}</div>
          <ml-textarea v-else class="w-full" rows="5" v-model="form.도급비고" :readonly="board.readonly" />
        </div>
      </div>

      <file-upload-module v-if="!isPrint" v-model="form.fileList" class="w-full" :isPrint="isPrint" :readonly="board.readonly" />
    </div>
  </div>
</template>

<script>
import RadioGroup from "@/components/radio/RadioGroup.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import AttendeeTableTwoColumn from "@/components/AttendeeTableTwoColumn.vue";
import SafetyInfoSurveyTable from "@/views/boards/single-page/1154/SafetyInfoSurveyTable.vue";
import TableCustom from "@/components/TableCustom.vue";
import TimeSelectorRang from "@/components/selector/TimeSelectorRang.vue";

export default {
  components: {
    TimeSelectorRang,
    TableCustom,
    AttendeeTableTwoColumn,
    DateSelectorRang,
    RadioGroup,
    FileUploadModule,
    SafetyInfoSurveyTable,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  async created() {},
  data() {
    return {
      form: {
        stdInfo: {},
        작업공정: "",
        생산품_1: "",
        생산품_2: "",
        근로자수: "",
        안전보건정보조사결과: [],
        작업절차정보: "공단 고위험작업(근골격계질환, 악성민원 대응) 표준 [참고2]\n" + "공단 응급상황 대응매뉴얼(안전사고, 출장 등) [참고3]",
        재해통계정보: "공단 산업재해 현황 : 4건 발생\n" + "2024년 산업재해 현황(고용노동부) : 0건\n" + "2025년 아차사고 공모 접수작 [참고4]",
        유해위험요인정보:
          "[참고5]\n" +
          "안전보건물질자료 작성지침(한국산업안전보건공단)\n" +
          "* 안전보건공단 화학물질 정보 사이트 활용(https://msds.kosha.or.kr/MSDSInfo)\n" +
          "사업장 내 위험작업 기계/기구/설비 및 MSDS등 유해물질 보유 현황 : \n" +
          "* 예시) 손소독제(에틴알코올)",
        작업상황정보: [],
        특이사항유무: "",
        특이사항: "2025년 소속근로자의 건강검진 결과 특이사항 확인 (소속근로자와 면담을 통해 확인)\n" +
          "(예시) 장시간 사무업무로 디스크 및 거북목 질환이 발생하여 치료를 받는 등 유사상황 1건\n" +
          "(예시) 민원 응대로 심리치료 및 정신과 방문 경험 등 유사상황 1건",
        도급유무: "",
        도급기간: {},
        도급정보: [],
        도급비고: "",
        fileList: [],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    isMobile() {
      return this.$store.state.windowWidth <= 768;
    },
  },
};
</script>
<style lang="scss" scoped>
.mid-title {
  font-size: 14px;
  font-weight: 700;
}
.mid-subtitle {
  font-size: 13px;
  font-weight: 400;
  color: #696D71;
}
</style>